import { StaticBaseDao } from '@/dao';
import {
    RaceContestant,
    SetRaceContestantExitStatusRequest,
    PostResponse,
    SetRaceContestantStartingTimeRequest,
    IntArray,
} from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';

export class RaceContestantDao extends StaticBaseDao {
    public static async GetRaceContestantsForEvent(EventId: number): Promise<RaceContestant[]> {
        return this.BaseFetchArray(
            RaceContestant,
            `RaceContestant/GetRaceContestantsForEvent` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'GET',
        );
    }
    public static async SetRaceContestantsExitStatus(
        EventId: number,
        setRaceContestantExitStatusRequest: SetRaceContestantExitStatusRequest,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestant/SetRaceContestantsExitStatus` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'POST',
            setRaceContestantExitStatusRequest,
        );
    }
    public static async MoveRaceContestantToNewHeat(
        EventId: number,
        RaceContestantId: number,
        NewRaceId: number,
        NewGroupId: number,
        NewStartingTime: Date | null,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestant/MoveRaceContestantToNewHeat` +
                '?' +
                (EventId == undefined ? '' : `EventId=${EventId}`) +
                '&' +
                (RaceContestantId == undefined ? '' : `RaceContestantId=${RaceContestantId}`) +
                '&' +
                (NewRaceId == undefined ? '' : `NewRaceId=${NewRaceId}`) +
                '&' +
                (NewGroupId == undefined ? '' : `NewGroupId=${NewGroupId}`) +
                '&' +
                (NewStartingTime == undefined ? '' : `NewStartingTime=${NewStartingTime ? formatDateIso(NewStartingTime) : null}`),
            'GET',
        );
    }
    public static async SetRaceContestantStartingTime(
        EventId: number,
        setRaceContestantStartingTimeRequest: SetRaceContestantStartingTimeRequest,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestant/SetRaceContestantStartingTime` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'POST',
            setRaceContestantStartingTimeRequest,
        );
    }
    public static async ConfirmPhotoFinish(EventId: number, raceContestantIds: IntArray): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestant/ConfirmPhotoFinish` + '?' + (EventId == undefined ? '' : `EventId=${EventId}`),
            'POST',
            raceContestantIds,
        );
    }
}
